module.exports = new __parcel__URL__("pairs_created.0fd9430a.png").toString();